<template>
    <div class="contact-filters-toolbar">
        <CommonFilterTool
            v-model="breakdownFilter"
            :keep-state-on-query-params="false"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @addFilter="addFilter"
            :showClearAll="isClearAllEnabled()"
            @applyFilterTemplate="applyFilterTemplate"
            :filter-templates="getFilterTemplates()"
            :selected-filter-template="getSelectedFilterTemplateName()"
            :hide-filters="this.selectedCustomFilterTemplate !== 'custom'"
            :show-add-button="this.selectedCustomFilterTemplate === 'custom'"
            :required-filters="getRequiredBreakdowns()"
        >
            <template slot="extra">
                <slot name="extra" />
            </template>
        </CommonFilterTool>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CommonFilterTool from "../../../views/Pages/Chatbot/pages/archive/CommonFilterTool.vue";
import log2 from "../../../utils/log2";
import _ from "lodash";
import moment from "moment";
import { UtilFunctions } from "../../../utils/UtilFunctions";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";

const log = log2("ContactListFilterToolBar");
export default {
    name: "ContactListFilterToolBar",
    components: { CommonFilterTool },
    data() {
        return {
            defaultFilterTemplate: "all-agent-inbox",
            filterMetas: [
                {
                    name: "selectedInteractions",
                    label: this.$t("chatWindow.interaction"),
                    materialIcon: "support_agent",
                    controlType: "agent-picker",
                    controlProps: {
                        addNone: true,
                        addChatbot: true,
                        addBroadcast: true,
                        addAPI: true,
                        addAutomation: true,
                    },
                    defaultValue: [
                        {
                            type: "agent",
                            value: this.$store.state.auth.user?._id,
                        },
                    ],
                },
                {
                    name: "selectedDepartmentIds",
                    label: this.$t("chatWindow.departments"),
                    materialIcon: "business",
                    controlType: "department-picker",
                    controlProps: {},
                    defaultValue: [],
                },
                {
                    name: "selectedChannelIds",
                    label: this.$t("chatWindow.channels"),
                    materialIcon: "hub",
                    controlType: "channel-picker",
                    controlProps: {
                        multiple: true,
                        includeDeleted: true,
                        autoSelectFirst: false,
                        allowedTypes: ["whatsapp-qr", "whatsapp-v2", "whatsapp-business-api", "instagram", "messenger"],
                    },
                    defaultValue: [],
                },
                {
                    name: "dateFilter",
                    label: this.$t("chatWindow.date"),
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    clearable: false,
                    defaultValue: {
                        timeSelect: "last24h",
                        startDate: null,
                        endDate: null,
                    },
                },
                {
                    name: "lastChatStatusList",
                    label: this.$t("chatWindow.lastChatStatus"),
                    materialIcon: "comment_bank",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: true,
                        idKey: "id",
                        labelKey: "label",
                        title: "Select Last Chat Status",
                    },
                    defaultValue: [],
                    options: () => [
                        {
                            id: null,
                            label: this.$t("chatWindow.all"),
                        },
                        {
                            id: "new",
                            label: this.$t("chatWindow.queued"),
                        },
                        {
                            id: "active",
                            label: this.$t("chatWindow.open"),
                        },
                        {
                            id: "destroyed",
                            label: this.$t("chatWindow.closed"),
                        },
                        {
                            id: "private",
                            label: this.$t("chatWindow.private"),
                        },
                        {
                            id: "chatbot",
                            label: this.$t("chatWindow.chatbot"),
                        },
                        {
                            id: "lost",
                            label: this.$t("chatWindow.lostMissed"),
                        },
                    ],
                },
                {
                    name: "lastChatOwner",
                    label: "Son Chatin Sahipleri",
                    materialIcon: "person",
                    controlType: "agent-picker",
                    controlProps: {
                        addNone: true,
                        addChatbot: false,
                        addBroadcast: false,
                        addAPI: false,
                        addAutomation: false,
                    },
                    defaultValue: [
                        {
                            type: "agent",
                            value: this.$store.state.auth.user?._id,
                        },
                    ],
                },
            ],
            breakdownFilter: [
                {
                    name: "dateFilter",
                    label: this.$t("chatWindow.date"),
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    clearable: false,
                    filterValue: {
                        timeSelect: "last24h",
                        startDate: null,
                        endDate: null,
                    },
                },
                {
                    name: "selectedInteractions",
                    label: this.$t("chatWindow.interaction"),
                    materialIcon: "support_agent",
                    controlType: "agent-picker",
                    controlProps: {
                        addNone: true,
                        addChatbot: true,
                        addBroadcast: true,
                        addAPI: true,
                        addAutomation: true,
                    },
                    filterValue: [
                        {
                            type: "agent",
                            value: this.$store.state.auth.user?._id,
                        },
                    ],
                },
                {
                    name: "lastChatOwner",
                    label: "Son Chatin Sahipleri",
                    materialIcon: "person",
                    controlType: "agent-picker",
                    controlProps: {
                        addNone: true,
                        addChatbot: false,
                        addBroadcast: false,
                        addAPI: false,
                        addAutomation: false,
                    },
                    filterValue: [
                        {
                            type: "agent",
                            value: this.$store.state.auth.user?._id,
                        },
                    ],
                },
                {
                    name: "lastChatStatusList",
                    label: this.$t("chatWindow.lastChatStatus"),
                    materialIcon: "comment_bank",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: true,
                        idKey: "id",
                        labelKey: "label",
                        title: "Select Last Chat Status",
                    },
                    filterValue: ["active"],
                    options: () => [
                        {
                            id: null,
                            label: this.$t("chatWindow.all"),
                        },
                        {
                            id: "new",
                            label: this.$t("chatWindow.queued"),
                        },
                        {
                            id: "active",
                            label: this.$t("chatWindow.open"),
                        },
                        {
                            id: "destroyed",
                            label: this.$t("chatWindow.closed"),
                        },
                        {
                            id: "private",
                            label: this.$t("chatWindow.private"),
                        },
                        {
                            id: "chatbot",
                            label: this.$t("chatWindow.chatbot"),
                        },
                        {
                            id: "lost",
                            label: this.$t("chatWindow.lostMissed"),
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            departments: (state) => state.subject.subjects.data,
            channels: (state) => state.channel.channels,
            contactListFilters: (state) => state.chat.contactListFilters,
            previousContactListFilters: (state) => state.chat.previousContactListFilters,
            selectedCustomFilterTemplate: (state) => state.chat.selectedCustomFilterTemplate,
        }),
    },
    mounted() {
        log("mounted", {
            previousContactListFilters: !!this.previousContactListFilters,
        });
    },
    created() {
        if (!this.selectedCustomFilterTemplate) {
            this.applyFilterTemplate(this.defaultFilterTemplate);
        } else {
            this.applyFilterTemplate(this.selectedCustomFilterTemplate);

            // if (this.previousContactListFilters) {
            //     log("recalculateBreakdownFilters calling from created", this.previousContactListFilters);
            //     this.recalculateBreakdownFilters(this.contactListFilters);
            // } else {
            //     log("publishBreakdownFilters calling from created");
            //     this.publishBreakdownFilters("created");
            // }

            const sub = SYSTEM_PUBSUB.stream.subscribe(({ type, payload }) => {
                if (type === SYSTEM_PUBSUB.MESSAGE_TYPES.APPLY_FILTER_TEMPLATE) {
                    this.applyFilterTemplate(payload);
                }
            });
            this.$once("hook:beforeDestroy", () => {
                sub.unsubscribe();
            });
        }
    },
    methods: {
        ...mapActions({
            updateContactFilters: "chat/updateContactFilters",
            setSelectedCustomFilterTemplate: "chat/setSelectedCustomFilterTemplate",
        }),
        getRequiredBreakdowns() {
            const templates = this.getFilterTemplates();
            return templates.find((x) => x.name === this.selectedCustomFilterTemplate)?.requiredBreakdowns || [];
        },
        getFilterTemplates() {
            /** Filter Ideas
             *  bu ayki kaçan kişiler (interactions none
             *  Kuyrukta Bekleyenler
             *  Whatsapp Aktif Chatleri
             *  Sosyal Medya Aktif Chatler
             *
             */
            return [
                {
                    name: "custom",
                    label: this.$t("chatWindow.special"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["active"],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "lastChatStatusList", "lastChatOwner"],
                },
                {
                    name: "my-active-inbox",
                    label: this.$t("chatWindow.myActiveInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["active"],
                        selectedInteractions: [
                            {
                                type: "agent",
                                value: this.$store.state.auth.user?._id,
                            },
                        ],
                        lastChatOwner: [
                            {
                                type: "agent",
                                value: this.$store.state.auth.user?._id,
                            },
                        ],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions", "lastChatStatusList", "lastChatOwner"],
                },
                {
                    name: "my-all-inbox",
                    label: this.$t("chatWindow.myInteractions"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: [],
                        selectedInteractions: [
                            {
                                type: "agent",
                                value: this.$store.state.auth.user?._id,
                            },
                        ],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: [
                        "dateFilter",
                        "selectedInteractions",
                        "selectedDepartmentIds",
                        "lastChatStatusList",
                        "selectedChannelIds",
                        "lastChatOwner",
                    ],
                    requiredBreakdowns: ["dateFilter"],
                    otherParameters: {
                        limit: 25,
                        groupBy: "none",
                        sort: "chat.create.desc",
                    },
                },
                {
                    name: "all-inbox",
                    label: this.$t("chatWindow.allInteractions"),
                    filter: () => ({
                        timeSelect: "",
                        startDate: null,
                        endDate: null,
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: [],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: [
                        "selectedInteractions",
                        "selectedDepartmentIds",
                        "lastChatStatusList",
                        "selectedChannelIds",
                        "lastChatOwner",
                    ],
                    requiredBreakdowns: ["dateFilter"],
                    otherParameters: {
                        limit: 25,
                        groupBy: "none",
                        sort: "chat.create.desc",
                    },
                },
                {
                    name: "active-and-queue-inbox",
                    label: this.$t("chatWindow.activeQueueInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["active", "new"],
                        selectedInteractions: [
                            {
                                type: "agent",
                                value: this.$store.state.auth.user?._id,
                            },
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                        lastChatOwner: [
                            {
                                type: "agent",
                                value: this.$store.state.auth.user?._id,
                            },
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions", "lastChatStatusList", "lastChatOwner"],
                    otherParameters: {
                        limit: 100,
                        groupBy: "agent",
                        sort: "chat.create.desc",
                    },
                },
                {
                    name: "all-agent-inbox",
                    label: this.$t("message.liveFabListDescription"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["active"],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "lastChatStatusList"],
                    otherParameters: {
                        limit: 1000,
                        groupBy: "agent",
                        sort: "chat.create.desc",
                    },
                },
                {
                    name: "queue-inbox",
                    label: this.$t("chatWindow.queueInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["new"],
                        selectedInteractions: [
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                        lastChatOwner: [
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions", "lastChatStatusList", "lastChatOwner"],
                },
                {
                    name: "chatbot-active-inbox",
                    label: this.$t("chatWindow.chatbotActiveInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: ["chatbot"],
                        selectedInteractions: [
                            {
                                type: "chatbot",
                                value: "chatbot",
                            },
                        ],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions", "lastChatStatusList"],
                },
                {
                    name: "my-departments-active-inbox",
                    label: this.$t("chatWindow.myDepartmentsActiveInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds:
                            this.user.subjects.length > 0 ? this.user.subjects : this.departments.map((x) => x._id),
                        selectedChannelIds: [],
                        lastChatStatusList: ["active", "new", "chatbot"],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedDepartmentIds", "lastChatStatusList"],
                },

                //Whatsapp Aktif Chatleri
                {
                    name: "whatsapp-active-inbox",
                    label: this.$t("chatWindow.whatsappActiveInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: this.channels
                            .filter((x) => x.type.startsWith("whatsapp"))
                            .map((x) => x._id),
                        lastChatStatusList: ["new", "active", "chatbot"],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedChannelIds", "lastChatStatusList"],
                },
                //Sosyal Medya Aktif Chatler
                {
                    name: "social-media-active-inbox",
                    label: this.$t("chatWindow.socialMediaActiveInbox"),
                    filter: () => ({
                        timeSelect: "last24h",
                        startDate: moment().startOf("day").toISOString(),
                        endDate: moment().endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: this.channels
                            .filter((x) => x.type.startsWith("instagram") || x.type.startsWith("messenger"))
                            .map((x) => x._id),
                        lastChatStatusList: ["new", "active", "chatbot"],
                        selectedInteractions: [],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedChannelIds", "lastChatStatusList"],
                },
                {
                    name: "yesterday-not-interacted",
                    label: this.$t("chatWindow.notInteractedYesterday"),
                    filter: () => ({
                        timeSelect: "-day",
                        startDate: moment().subtract(1, "day").startOf("day").toISOString(),
                        endDate: moment().subtract(1, "day").endOf("day").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: [],
                        selectedInteractions: [
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions"],
                },
                //Bu Ayki Kaçan Kişiler
                {
                    name: "missed-this-month",
                    label: this.$t("chatWindow.missedThisMonth"),
                    filter: () => ({
                        timeSelect: "month",
                        startDate: moment().startOf("month").toISOString(),
                        endDate: moment().endOf("month").toISOString(),
                        query: "",
                        selectedDepartmentIds: [],
                        selectedChannelIds: [],
                        lastChatStatusList: [],
                        selectedInteractions: [
                            {
                                type: "none",
                                value: "none",
                            },
                        ],
                        lastChatOwner: [],
                    }),
                    requiredFilterNames: ["dateFilter", "selectedInteractions"],
                },
            ];
        },
        applyFilterTemplate(name) {
            const template = this.getFilterTemplates().find((x) => x.name === name);
            log("applyFilterTemplate", name, template);

            if (template) {
                const filter = template.filter();
                const oldFilters = this.contactListFilters;
                const newFilters = {
                    ...oldFilters,
                    ...filter,
                };
                let requiredFilterNames = template.requiredFilterNames || [];

                const filterMetas = this.filterMetas.filter((x) => requiredFilterNames.includes(x.name));

                let currentBreakdowns = [];
                // currentBreakdowns = currentBreakdowns.filter((x) => x.name === "dateFilter");
                filterMetas.forEach((meta) => {
                    const item = {
                        ...meta,
                    };
                    if (meta.name === "dateFilter") {
                        item.filterValue = {
                            timeSelect: newFilters.timeSelect,
                            startDate: newFilters.startDate,
                            endDate: newFilters.endDate,
                        };
                    } else if (meta.name === "selectedInteractions") {
                        item.filterValue = newFilters.selectedInteractions;
                    } else if (meta.name === "selectedDepartmentIds") {
                        item.filterValue = newFilters.selectedDepartmentIds;
                    } else if (meta.name === "selectedChannelIds") {
                        item.filterValue = newFilters.selectedChannelIds;
                    } else if (meta.name === "lastChatStatusList") {
                        item.filterValue = newFilters.lastChatStatusList;
                    } else if (meta.name === "lastChatOwner") {
                        item.filterValue = newFilters.lastChatOwner;
                    }
                    currentBreakdowns.push(item);
                });
                log("applyFilterTemplate", {
                    name,
                    filter,
                    requiredFilterNames,
                    filterMetas,
                    currentBreakdowns,
                    newFilters,
                });
                log("updateContactFilters calling from applyFilterTemplate", {
                    newFilters,
                    oldFilters: this.contactListFilters,
                });
                this.publishDisabled = true;
                this.breakdownFilter = _.cloneDeep(currentBreakdowns);
                log("applyFilterTemplate - updateContactFilters");
                this.updateContactFilters(newFilters);
                if (template.otherParameters?.sort) {
                    this.$store.dispatch("chat/setContactListSortMode", template.otherParameters.sort);
                } else {
                    this.$store.dispatch("chat/setContactListSortMode", "chat.create.desc");
                }

                if (template.otherParameters?.limit) {
                    this.$store.dispatch("chat/setContactPaginationOffset", {
                        limit: template.otherParameters.limit,
                        skip: 0,
                    });
                } else {
                    const isSame = _.isEqual(this.$store.state.chat.contactPaginationCursor.offset, {
                        limit: 25,
                        skip: 0,
                    });

                    if (!isSame) {
                        this.$store.dispatch("chat/setContactPaginationOffset", {
                            limit: 25,
                            skip: 0,
                        });
                    }
                }
                if (template.otherParameters?.groupBy) {
                    this.$store.dispatch("chat/setContactListGroupBy", template.otherParameters.groupBy);
                } else {
                    this.$store.dispatch("chat/setContactListGroupBy", "none");
                }
                this.setSelectedCustomFilterTemplate(name);

                setTimeout(() => {
                    this.publishDisabled = false;
                }, 1000);
            }
        },
        getSelectedFilterTemplateName() {
            const templates = this.getFilterTemplates();
            if (this.selectedCustomFilterTemplate) {
                return templates.find((x) => x.name === this.selectedCustomFilterTemplate)?.label;
            }
            const selectedTemplate = templates.find((x) => {
                const filter = x.filter();
                const isMatched = Object.keys(filter)
                    .map((key) => {
                        const ignoreFields = ["startDate", "endDate"];
                        if (ignoreFields.includes(key)) {
                            return true;
                        }
                        return _.isEqual(filter[key], this.contactListFilters[key]);
                    })
                    .every((key) => {
                        return key;
                    });
                return isMatched;
            });
            return selectedTemplate?.label;
        },
        isClearAllEnabled() {
            return this.breakdownFilter.length > 1;
        },
        getDepartmentName(department) {
            return (
                _.get(department, `languageContent.${this.$i18n.locale}.name`) ||
                _.get(department, `languageContent.${Object.keys(department.languageContent)[0]}.name`)
            );
        },

        addFilter(name, value) {
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.breakdownFilter.find((x) => x.name === name);
            log.info("addFilter", { name, value, meta, filter });
            if (filter) {
                this.breakdownFilter = this.breakdownFilter.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                    }
                    return x;
                });
            } else {
                this.breakdownFilter.push({
                    ...meta,
                    filterValue: value || meta.defaultValue,
                });
            }
            setTimeout(() => {
                const el = document.querySelector(".filter-wrapper-preview[data-filter-name=" + name + "]");
                if (el) {
                    el.click();
                }
            }, 100);
        },
        removeFilter(name) {
            log.info("removeFilter", name);
            this.breakdownFilter = this.breakdownFilter.filter((x) => x.name !== name);
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            const isSelect = filter.controlType === "select";

            if (isSelect) {
                const option = filter.options().find((x) => x.id === value);
                if (option) {
                    if (filter.name === "lastChatStatus") {
                        return `${option.label}`;
                    } else {
                        return `${filter.label}: ${option.label}`;
                    }
                }
            } else if (filter.controlType === "agent-picker") {
                const count = (value || []).length;
                if (count === 0) {
                    return filter.label;
                } else if (count === 1) {
                    const items = [
                        ...this.users.map((x) => ({
                            ...x,
                            name: x._id === this.$store.state.auth.user?._id ? this.$t("chatWindow.me") : x.name,
                        })),

                        {
                            _id: "chatbot",
                            name: "Chatbot",
                        },
                        {
                            _id: "broadcast",
                            name: "Broadcast",
                        },
                        {
                            _id: "api",
                            name: "API",
                        },
                        {
                            _id: "automation",
                            name: "Automation",
                        },
                        {
                            _id: "none",
                            name: "Anyone",
                        },
                    ];
                    return `${items.find((x) => x._id === value[0].value)?.name}`;
                } else {
                    return `${count} selected`;
                }
            } else if (filter.controlType === "custom-picker") {
                if (filter.controlProps.multiple) {
                    const count = (value || []).length;
                    if (count === 0) {
                        return filter.label;
                    } else if (count === 1) {
                        const items = filter.options();
                        const option = items.find((x) => x[filter.controlProps.idKey] === value[0]);
                        return `${option?.label}`;
                    } else {
                        return `${count} selected`;
                    }
                } else {
                    const option = filter.options().find((x) => x.id === value);
                    return `${filter.label}: ${option.label}`;
                }
            } else if (filter.controlType === "department-picker") {
                const count = (value || []).length;
                if (count === 0) {
                    return filter.label;
                } else if (count === 1) {
                    return `${this.getDepartmentName(this.departments.find((x) => x._id === value[0]))}`;
                } else {
                    return `${count} selected`;
                }
            } else if (filter.controlType === "channel-picker") {
                const count = (value || []).length;
                if (count === 0) {
                    return filter.label;
                } else if (count === 1) {
                    return `${this.channels.find((x) => x._id === value[0])?.name}`;
                } else {
                    return `${count} selected`;
                }
            } else if (filter.controlType === "date-range-picker") {
                const shortcuts = {
                    today: this.$t("chatWindow.today"),
                    day: this.$t("chatWindow.today"),
                    "-day": this.$t("chatWindow.yesterday"),
                    isoWeek: this.$t("chatWindow.thisWeek"),
                    "-isoWeek": this.$t("chatWindow.lastWeek"),
                    7: this.$t("chatWindow.last7Days"),
                    30: this.$t("chatWindow.last30Days"),
                    month: this.$t("chatWindow.thisMonth"),
                    "-month": this.$t("chatWindow.lastMonth"),
                    yesterday: this.$t("chatWindow.yesterday"),
                    "last-7-days": this.$t("chatWindow.last7Days"),
                    "last-30-days": this.$t("chatWindow.last30Days"),
                    thisWeek: this.$t("chatWindow.thisWeek"),
                    lastWeek: this.$t("chatWindow.lastWeek"),
                    thisMonth: this.$t("chatWindow.thisMonth"),
                    lastMonth: this.$t("chatWindow.lastMonth"),
                    last24h: this.$t("chatWindow.last24h"),
                    custom: this.$t("chatWindow.custom"),
                    ..._.range(2, 13)
                        .map((i) => ({
                            key: `month${i}`,
                            label: moment().subtract(i, "month").format("MMMM YYYY"),
                        }))
                        .reduce((acc, item) => {
                            acc[item.key] = item.label;
                            return acc;
                        }, {}),
                };
                if (value.timeSelect && value.timeSelect !== "custom") {
                    return `${shortcuts[value.timeSelect]}`;
                } else {
                    const startDate = moment(value.startDate).format("DD MMM YYYY");
                    const endDate = value.endDate ? moment(value.endDate).format("DD MMM YYYY") : "now";

                    if (startDate === endDate) {
                        return `${startDate}`;
                    } else {
                        return `${startDate} - ${endDate}`;
                    }
                }
            }

            if (value) {
                return `${value}`;
            }
            return filter.label;
        },
        isFilterExists(name) {
            return !!this.breakdownFilter.find((x) => x.name === name);
        },
        getStartDateFromFilter() {
            const meta = this.breakdownFilter.find((x) => x.name === "dateFilter");
            const timeSelect = meta?.filterValue?.timeSelect;

            let result = {
                today: moment().startOf("day").toISOString(),
                yesterday: moment().subtract(1, "day").startOf("day").toISOString(),
                thisWeek: moment().startOf("isoWeek").toISOString(),
                lastWeek: moment().subtract(1, "week").startOf("isoWeek").toISOString(),
                last7Days: moment().subtract(7, "day").startOf("day").toISOString(),
                last30Days: moment().subtract(30, "day").startOf("day").toISOString(),
                thisMonth: moment().startOf("month").toISOString(),
                lastMonth: moment().subtract(1, "month").startOf("month").toISOString(),
                last24h: moment().subtract(1, "day").toISOString(),
                ..._.range(2, 13)
                    .map((i) => ({
                        key: `month${i}`,
                        label: moment().subtract(i, "month").format("MMMM YYYY"),
                        value: () => {
                            return {
                                start: moment().subtract(i, "month").startOf("month"),
                                end: moment().subtract(i, "month").endOf("month"),
                            };
                        },
                    }))
                    .reduce((acc, item) => {
                        acc[item.key] = item.value().start.toISOString();
                        return acc;
                    }, {}),
            }[timeSelect];
            if (result) return result;
            else {
                return meta?.filterValue?.startDate;
            }
        },
        getEndDateFromFilter() {
            const meta = this.breakdownFilter.find((x) => x.name === "dateFilter");
            const timeSelect = meta?.filterValue?.timeSelect;

            let result = {
                today: moment().endOf("day").toISOString(),
                yesterday: moment().subtract(1, "day").endOf("day").toISOString(),
                thisWeek: moment().endOf("isoWeek").toISOString(),
                lastWeek: moment().subtract(1, "week").endOf("isoWeek").toISOString(),
                last7Days: moment().subtract(1, "day").endOf("day").toISOString(),
                last30Days: moment().subtract(1, "day").endOf("day").toISOString(),
                thisMonth: moment().endOf("month").toISOString(),
                lastMonth: moment().subtract(1, "month").endOf("month").toISOString(),
                last24h: moment().endOf("day").toISOString(),
                ..._.range(2, 13)
                    .map((i) => ({
                        key: `month${i}`,
                        label: moment().subtract(i, "month").format("MMMM YYYY"),
                        value: () => {
                            return {
                                start: moment().subtract(i, "month").startOf("month"),
                                end: moment().subtract(i, "month").endOf("month"),
                            };
                        },
                    }))
                    .reduce((acc, item) => {
                        acc[item.key] = item.value().end.toISOString();
                        return acc;
                    }, {}),
            }[timeSelect];
            if (result) return result;
            else {
                return meta?.filterValue?.endDate;
            }
        },
        compareFilters(filter1, filter2) {
            /**
             * - timeSelect undefined-undefined ise tam kıyaslama yap
             * - timeSelect undefined-X ise tam kıyaslama yap
             * - timeSelect  X-X ise startDate ve endDate'leri hesapa katma
             */
            if (filter1.timeSelect === filter2.timeSelect && !!filter1.timeSelect && !!filter2.timeSelect) {
                const keys = Object.keys(filter2).filter((x) => !["startDate", "endDate"].includes(x));
                return _.isEqual(_.pick(filter1, keys), _.pick(filter2, keys));
            }
            return _.isEqual(filter1, filter2);
        },
        publishBreakdownFilters(ignoreSource) {
            log(
                `publishBreakdownFilters running from ignoreSource=${ignoreSource} publishDisabled = ${this.publishDisabled}`
            );
            if (this.publishDisabled) return;

            const selectedInteractions =
                this.breakdownFilter.find((x) => x.name === "selectedInteractions")?.filterValue || [];
            const oldSelectedInteractions = this.contactListFilters.selectedInteractions;
            const isInteractionsFilterChanged = !_.isEqual(selectedInteractions, oldSelectedInteractions);

            const selectedDepartmentIds =
                this.breakdownFilter.find((x) => x.name === "selectedDepartmentIds")?.filterValue || [];
            const oldSelectedDepartmentIds = this.contactListFilters.selectedDepartmentIds;
            const isDepartmentChanged = !_.isEqual(selectedDepartmentIds, oldSelectedDepartmentIds);

            const selectedChannelIds =
                this.breakdownFilter.find((x) => x.name === "selectedChannelIds")?.filterValue || [];
            const oldSelectedChannelIds = this.contactListFilters.selectedChannelIds;
            const isChannelChanged = !_.isEqual(selectedChannelIds, oldSelectedChannelIds);

            const startDate = this.getStartDateFromFilter();
            const oldStartDate = this.contactListFilters.startDate;
            const isStartDateChanged = !_.isEqual(startDate, oldStartDate);

            const endDate = this.getEndDateFromFilter();
            const oldEndDate = this.contactListFilters.endDate;
            const isEndDateChanged = !_.isEqual(endDate, oldEndDate);

            const timeSelect = this.breakdownFilter.find((x) => x.name === "dateFilter")?.filterValue?.timeSelect;
            const oldTimeSelect = this.contactListFilters.timeSelect;
            const isTimeSelectChanged = !_.isEqual(timeSelect, oldTimeSelect);

            const lastChatStatusList = this.breakdownFilter.find((x) => x.name === "lastChatStatusList")?.filterValue;
            const oldLastChatStatusList = this.contactListFilters.lastChatStatusList;
            const isLastChatStatusListChanged = !_.isEqual(lastChatStatusList, oldLastChatStatusList);

            const lastChatOwner = this.breakdownFilter.find((x) => x.name === "lastChatOwner")?.filterValue;
            const oldLastChatOwner = this.contactListFilters.lastChatOwner;
            const isLastChatOwnerChanged = !_.isEqual(lastChatOwner, oldLastChatOwner);

            const newFilters = {
                ...this.contactListFilters,
                selectedInteractions: isInteractionsFilterChanged ? selectedInteractions : oldSelectedInteractions,
                selectedDepartmentIds: isDepartmentChanged ? selectedDepartmentIds : oldSelectedDepartmentIds,
                selectedChannelIds: isChannelChanged ? selectedChannelIds : oldSelectedChannelIds,
                startDate: isStartDateChanged ? startDate : oldStartDate,
                endDate: isEndDateChanged ? endDate : oldEndDate,
                timeSelect: isTimeSelectChanged ? timeSelect : oldTimeSelect,
                lastChatStatusList: isLastChatStatusListChanged ? lastChatStatusList : oldLastChatStatusList,
                lastChatOwner: isLastChatOwnerChanged ? lastChatOwner : oldLastChatOwner,
            };
            const isChanged = !this.compareFilters(newFilters, this.contactListFilters);
            if (isChanged) {
                log("updateContactFilters calling from publishBreakdownFilters", {
                    newFilters,
                    oldFilters: this.contactListFilters,
                });
                const diff = UtilFunctions.difference(this.contactListFilters, newFilters);
                log.debug("publishBreakdownFilters diff", diff);
                log("publishBreakdownFilters - updateContactFilters");
                this.updateContactFilters(newFilters);
            }
        },
        recalculateBreakdownFilters(contactListFilters) {
            log("recalculateBreakdownFilters", contactListFilters);
            this.publishDisabled = true;
            setTimeout(() => {
                this.publishDisabled = false;
            }, 1000);
            this.breakdownFilter = this.breakdownFilter.map((meta) => {
                return {
                    ...meta,
                    filterValue:
                        {
                            selectedInteractions:
                                meta.name === "selectedInteractions"
                                    ? contactListFilters.selectedInteractions
                                    : meta.filterValue,
                            selectedDepartmentIds:
                                meta.name === "selectedDepartmentIds"
                                    ? contactListFilters.selectedDepartmentIds
                                    : meta.filterValue,
                            selectedChannelIds:
                                meta.name === "selectedChannelIds"
                                    ? contactListFilters.selectedChannelIds
                                    : meta.filterValue,
                            startDate: meta.name === "dateFilter" ? contactListFilters.startDate : meta.filterValue,
                            endDate: meta.name === "dateFilter" ? contactListFilters.endDate : meta.filterValue,
                            timeSelect: meta.name === "dateFilter" ? contactListFilters.timeSelect : meta.filterValue,
                            lastChatStatusList:
                                meta.name === "lastChatStatusList"
                                    ? contactListFilters.lastChatStatusList
                                    : meta.filterValue,
                            lastChatOwner:
                                meta.name === "lastChatOwner" ? contactListFilters.lastChatOwner : meta.filterValue,
                        }[meta.name] || meta.filterValue,
                };
            });
        },
    },
    watch: {
        breakdownFilter: {
            handler: function () {
                this.publishBreakdownFilters("watcher.breakdownFilter");
            },
            deep: true,
        },
        contactListFilters: {
            handler: function (newVal) {
                this.recalculateBreakdownFilters(newVal);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.contact-filters-toolbar {
    display: flex;
    width: 100%;

    .contact-filters-toolbar {
        margin-bottom: 10px;
    }

    .common-filter-tool {
        border-bottom: none;
        overflow: hidden;
        padding: 0px;

        .channel-picker-inline {
            .groups {
                max-height: 300px !important;
            }
        }

        .filters {
            //flex-wrap: unset !important;
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: none;
        }

        .add-button {
            margin: unset !important;
            border-radius: 20px;
            border: 1px dashed var(--color-border-default);
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;
            padding: 1px 5px !important;
            min-width: fit-content;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .clear-preview {
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .filter-wrapper-preview {
            border-radius: 20px;
            padding: 1px 5px !important;
            background: white;
            color: black;
            border: 1px solid var(--color-border-default);

            .filter-value-text {
                font-size: 12px;
                font-weight: 600;
                color: #22272d;
                line-height: 24px;
            }

            .material-icons {
                margin-right: 3px;
            }
        }
    }
}

.active-filters {
    display: flex;
    gap: 5px;
    overflow-x: auto;
    padding: 10px 0;
    overflow-y: hidden;

    &::-webkit-scrollbar {
        display: none;
    }

    .clear-active-filter {
        width: max-content;
        height: 30px;
        background-color: #000;
        color: #fff;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 7px;
        cursor: pointer;
    }

    .active-filter-group {
        display: flex;
        gap: 5px;
        height: 40px;
    }

    .active-filter {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 16px;
        padding: 10px 0 10px 10px;
        position: relative;
        width: max-content;
        height: 30px;
        border: 1px solid #d2d2d2;

        .remove-filter {
            cursor: pointer;
            background-color: #fff;
            border-radius: 50%;
            padding: 0 5px;
            margin-left: 5px;
            color: #d2d2d2;
            font-size: 15px;
            font-weight: 900;
        }
    }
}
</style>
